
import {defineComponent, ref} from 'vue'
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import {UIStateDto} from "@/dtos/UIStateDto";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import {I18nContext} from "@/context/I18nContext";
import CatalogBuildStatus from "@/components/layouts/catalog/CatalogBuildStatus.vue";
import MultilingualSwitcher from "@/components/UI/MultilingualSwitcher.vue";
import CustomerCategories from "@/components/layouts/catalog/categories/CustomerCategories.vue";
import RenameDPSubCategories from "@/components/layouts/catalog/categories/RenameDPSubCategories.vue";
import {AbilityContext} from "@/context/AbilityContext";
import MainCategories from "@/components/layouts/catalog/categories/MainCategories.vue";

export default defineComponent({
  name: "Categories",
  components: {
    MainCategories,
    CustomerCategories,
    RenameDPSubCategories,
    MultilingualSwitcher,
    CatalogBuildStatus,
    BaseContainer,
    AlertError2,
    BaseTitle,
  },
  props: {
    showBackRoute: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      categoriesUI: UIStateDto.createWithDefaults(),
      // Merk op, dit wordt énkel opgeroepen in geval van meertalige customers
      // Catalogus is momenteel énkel in nl en fr beschikbaar, daarom hardcoded
      allLanguages: ['nl', 'fr'],
      activeLanguage: I18nContext.getDefaultApiLanguageKey(),
      //Hack: an errors object has to be passed to the MultilingualSwitcher, but I can't use the errors object from the form,
      // because this switcher is not inside a form.
      languageSwitchErrors: ref([]),
      currentComponent: 'MainCategories' as string,

      criteriaInitialized: false as boolean,
      criteriaChanged: false as boolean,

      isCustomSortWeightsChecked: false,
      isBulkActionsOpen: false,
    }
  },
  mounted() {
    if (!AbilityContext.isAuthorizedForFeature('MULTILINGUAL')) {
      this.allLanguages = [I18nContext.getDefaultApiLanguageKey()];
    }
  },
  computed: {
    currentProperties(): object {
      return {
        "language": this.activeLanguage,
        "allLanguages": this.allLanguages
      };
    },
  },
  methods: {
    changeLanguage(newValue: string): void {
      this.activeLanguage = newValue;
    },
    setCurrentComponent(cmp: string) {
      this.currentComponent = cmp;
    },
    setExceptions(exceptions: unknown): void {
      ErrorHandlerQueue
        .create()
        .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.categoriesUI as UIStateDto))
        .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.categoriesUI as UIStateDto))
        .catch(exceptions, true);
    },
  }
})
